import http from '@/http.js'
import store from '@/store/index.js'

export default class AccountService {
  GetDistinctAccounts() {
    const promise = new Promise((resolve, reject) => {
      http.get(`/api/transaction/accounts/distinct`)
      .then((response) => { 
        store.commit('SetAccounts', response.data)
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })
    return promise    
  }
}